import Types from './Types';

const asList = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.tags)) return payload.tags;
    if (Array.isArray(payload?.exams)) return payload.exams;
    if (Array.isArray(payload?.data?.data)) return payload.data.data;
    return [];
};

const INITIAL_STATE = {
    studentExams: [],
    examQuestions: [],
    examQuestionsLoadError: null,
    activeExam: null,
    tags: [],
    isLoading: false,
    isCreating: false,
    tagsLoading: false,
    count: ''
};

export default function studentExams(state = INITIAL_STATE, action) {
    const { type, payload } = action;
    switch (type) {
        case Types.GET_STUDENT_EXAMS_SUCCESS: {
            const studentExams = asList(payload);
            return {
                ...state,
                studentExams,
                count: studentExams.length
            };
        }

        case Types.GET_STUDENT_TAGS_SUCCESS: {
            return {
                ...state,
                tags: asList(payload),
            };
        }

        case Types.CREATE_STUDENT_EXAMS_SUCCESS: {
            return {
                ...state,
            };
        }

        case Types.CREATE_TAG_EXAM_SUCCESS:
        case Types.RESTORE_TAG_EXAM_SESSION: {
            return {
                ...state,
                activeExam: payload?.exam || null,
                examQuestions: Array.isArray(payload?.questions) ? payload.questions : [],
                examQuestionsLoadError: null,
            };
        }

        case Types.CLEAR_TAG_EXAM_SESSION: {
            return {
                ...state,
                activeExam: null,
                examQuestions: [],
                examQuestionsLoadError: null,
            };
        }

        case Types.GET_STUDENT_EXAM_QUESTIONS_SUCCESS: {
            return {
                ...state,
                examQuestions: payload.data,
                examQuestionsLoadError: null,
            };
        }

        case Types.GET_STUDENT_EXAM_QUESTIONS_FAIL: {
            return {
                ...state,
                examQuestionsLoadError: payload || null,
            };
        }

        case Types.ADD_STUDENT_EXAMS_LOADING: {
            return {
                ...state,
                isLoading: payload
            };
        }

        case Types.ADD_STUDENT_EXAMS_CREATING: {
            return {
                ...state,
                isCreating: payload,
            };
        }

        case Types.ADD_STUDENT_TAGS_LOADING: {
            return {
                ...state,
                tagsLoading: payload,
            };
        }

        default: {
            return state;
        }
    }
}
